import React from "react";

const Input = ({ type, id, name, value, onChange, placeholder, label, options, checked }) => {
    if (type === "select") {
        return (
            <div className="form-floating mt-3">
                <select 
                    className="form-select floatingInput"
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    aria-label="Floating label select example"
                >
                    <option value="" selected disabled>--select--</option>
                    {options && options.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </select>
                <label className="floatingInput-label" htmlFor={id}>{label}</label>
            </div>
        );
    } else if (type === "radio") {
        return (
            <div className="form-check mt-4">
                <input
                    type="radio"
                    className="form-check-input"
                    id={id}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                />
                <label className="form-check-label" htmlFor={id}>
                    {label}
                </label>
            </div>
        );
    }
     else {
        return (
            <div className="form-floating mt-3">
                <input type={type} 
                className={`form-control floatingInput ${type === "date" ? "calendar-filter" : ""}`} 
                id={id} 
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder} />
                <label className="floatingInput-label" htmlFor="floatingInput">{label}</label>
            </div>
        )
    }
}

export default Input;
